import { useIntl } from 'react-intl';
import { SimpleGrid, Box, Flex } from '@chakra-ui/react';
import ComboboxFormikField from 'components/forms/ComboboxFormikField';
import CheckboxFormikField from 'components/forms/CheckboxFormikField';

const ModelDefinitionsTab = ({ options, basisModelTypeId }) => {
    const intl = useIntl();

    return (
        <Box>
            <Flex mb={6}>
                <CheckboxFormikField
                    id="lmpFlag"
                    name="lmpFlag"
                    label={intl.formatMessage({ id: 'basis_tabs_full_destination' })}
                />
                <CheckboxFormikField
                    id="hourlySim"
                    name="hourlySim"
                    label={intl.formatMessage({ id: 'basis_tabs_hourly_sim' })}
                />
                <CheckboxFormikField
                    id="forwardSim"
                    name="forwardSim"
                    label={intl.formatMessage({ id: 'basis_tabs_forward_sim' })}
                />
                <CheckboxFormikField
                    id="dailySim"
                    name="dailySim"
                    label={intl.formatMessage({ id: 'basis_tabs_daily_sim' })}
                />
            </Flex>
            <SimpleGrid spacingX={6} spacingY={5} columns={3}>
                <ComboboxFormikField
                    id="basisModelTypeId"
                    name="basisModelTypeId"
                    label={intl.formatMessage({ id: 'basis_tabs_basis_model_type' })}
                    options={options.basisModelTypes}
                    labelKey="description"
                    valueKey="id"
                    showPlaceholder={true}
                    placeholderValue={null}
                />
                <ComboboxFormikField
                    id="basicModelId"
                    name="basicModelId"
                    label={intl.formatMessage({ id: 'basis_tabs_basic_model' })}
                    options={options.basicModels}
                    labelKey="description"
                    valueKey="id"
                    isDisabled={basisModelTypeId !== 41}
                    showPlaceholder={true}
                    placeholderValue={null}
                />
                <ComboboxFormikField
                    id="moduleProcessId"
                    name="moduleProcessId"
                    label={intl.formatMessage({ id: 'basis_tabs_module_process' })}
                    options={options.moduleProcesses}
                    labelKey="description"
                    valueKey="id"
                    showPlaceholder={true}
                    placeholderValue={null}
                />
                <ComboboxFormikField
                    id="modelWeightId"
                    name="modelWeightId"
                    label={intl.formatMessage({ id: 'basis_tabs_model_weight' })}
                    options={options.modelWeights}
                    labelKey="description"
                    valueKey="id"
                    showPlaceholder={true}
                    placeholderValue={null}
                />
                <ComboboxFormikField
                    id="transformMethodId"
                    name="transformMethodId"
                    label={intl.formatMessage({ id: 'basis_tabs_transform_method' })}
                    options={options.transformMethods}
                    labelKey="description"
                    valueKey="id"
                    showPlaceholder={true}
                    placeholderValue={null}
                />
            </SimpleGrid>
        </Box>
    );
};

export default ModelDefinitionsTab;
